import ProjectConfig from 'ProjectConfig';

const firebaseConfig = ProjectConfig.firebaseSdkConfig ?? {};

let perf = null;

export default () => {
  let firebase;
  try {
    firebase = window.firebase?.app(); // Get existing app
  } catch (error) {
    firebase = window.firebase?.initializeApp(firebaseConfig);
  }

  let remoteConfig;
  if (!!firebase && !!firebase.remoteConfig) {
    remoteConfig = firebase?.remoteConfig();

    if (firebase.performance && !perf) {
      perf = firebase.performance();
    }

    if (remoteConfig) {
      remoteConfig.settings.minimumFetchIntervalMillis = 60000;
    }

    return {
      firebase,
      remoteConfig,
      perf,
    };
  }

  return {};
};

export const createCustomTrace = traceName => {
  if (!perf) {
    console.warn('Firebase Performance Monitoring not initialized');
    return null;
  }

  return perf.trace(traceName);
};

export const startBulletinTrace = (bulletinType, tabType) => {
  const environment = ProjectConfig.env || 'unknown';
  const traceName = `Bulletin - ${bulletinType}:${tabType}`;
  const customTrace = createCustomTrace(traceName);
  
  if (customTrace) {
    customTrace.putAttribute('bulletinType', bulletinType.toString());
    customTrace.putAttribute('tabType', tabType.toString());
    customTrace.putAttribute('environment', environment);
    customTrace.start();
  }
  
  return customTrace;
};

export const stopBulletinTrace = (customTrace, additionalMetrics = {}) => {
  if (customTrace) {
    // Add additional metrics if provided
    Object.keys(additionalMetrics).forEach(key => {
      if (typeof additionalMetrics[key] === 'number') {
        customTrace.incrementMetric(key, additionalMetrics[key]);
      } else {
        customTrace.putAttribute(key, additionalMetrics[key].toString());
      }
    });
    
    customTrace.stop();
  }
};

